import { memo } from "react";

import { motion } from "framer-motion";

import { Card, CardContent } from "@/components/ui/card";

import { ArrowDown, ArrowUp, Minus } from "lucide-react";

import AnimatedValue from "./AnimatedValue";

function TrendIcon({ trend }) {
  switch (trend) {
    case "up":
      return <ArrowUp className="h-4 w-4 text-green-600" />;

    case "down":
      return <ArrowDown className="h-4 w-4 text-red-600" />;

    default:
      return <Minus className="h-4 w-4 text-muted-foreground" />;
  }
}

function SummaryCards({ results, config = [] }) {
  return (
    <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
      {config.map((card) => {
        const rawValue = results.summary?.[card.key];

        const displayValue =
          card.displayKey && results.summary?.[card.displayKey]
            ? results.summary[card.displayKey]
            : rawValue;

        const Icon = card.icon;

        return (
          <motion.div
            key={card.key}
            layout
            initial={{
              opacity: 0,
              y: 10,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
          >
            <Card className="h-full">
              <CardContent className="flex h-full flex-col justify-between gap-6 p-6">
                <div className="flex items-start justify-between">
                  <div>
                    <p className="text-sm text-muted-foreground">
                      {card.title}
                    </p>

                    <h3 className="mt-3 text-2xl font-bold leading-none">
                      <AnimatedValue value={displayValue} type={card.type} />
                      {!card.displayKey && card.suffix && (
                        <span className="ml-1 text-lg font-medium text-muted-foreground">
                          {card.suffix}
                        </span>
                      )}
                    </h3>
                  </div>

                  {Icon && (
                    <div className="rounded-xl bg-primary/10 p-3">
                      <Icon className="h-6 w-6 text-primary" />
                    </div>
                  )}
                </div>

                {(card.description || card.trend) && (
                  <div className="flex items-center justify-between">
                    {card.description && (
                      <span className="text-xs text-muted-foreground">
                        {card.description}
                      </span>
                    )}

                    {card.trend && <TrendIcon trend={card.trend} />}
                  </div>
                )}
              </CardContent>
            </Card>
          </motion.div>
        );
      })}
    </div>
  );
}

export default memo(SummaryCards);
